var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M12.8555 4.5C7.85547 4.5 3.58547 7.61 1.85547 12C3.58547 16.39 7.85547 19.5 12.8555 19.5C17.8555 19.5 22.1255 16.39 23.8555 12C22.1255 7.61 17.8555 4.5 12.8555 4.5ZM12.8555 17C10.0955 17 7.85547 14.76 7.85547 12C7.85547 9.24 10.0955 7 12.8555 7C15.6155 7 17.8555 9.24 17.8555 12C17.8555 14.76 15.6155 17 12.8555 17ZM12.8555 9C11.1955 9 9.85547 10.34 9.85547 12C9.85547 13.66 11.1955 15 12.8555 15C14.5155 15 15.8555 13.66 15.8555 12C15.8555 10.34 14.5155 9 12.8555 9Z"}));
}

SVGIcon.defaultProps = {"viewBox":"0 0 25 24"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
